import { render, staticRenderFns } from "./SecondNewsBanner.vue?vue&type=template&id=a3592cf6&scoped=true&lang=pug&"
import script from "./SecondNewsBanner.vue?vue&type=script&lang=js&"
export * from "./SecondNewsBanner.vue?vue&type=script&lang=js&"
import style0 from "./SecondNewsBanner.vue?vue&type=style&index=0&id=a3592cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3592cf6",
  null
  
)

export default component.exports